import { useMemo } from 'react';
import useNappConfig from './useNappConfig';
import usePlanPermissions from './usePlanPermissions';

/**
 * Hook simplificado para verificar status da integração NAPP
 * Ideal para usar em componentes que precisam verificar se NAPP está configurado
 */
const useNappStatus = () => {
  const { config, loading, error } = useNappConfig();
  const { permissions } = usePlanPermissions();

  const status = useMemo(() => {
    // Se não tem permissão, retorna não disponível
    if (!permissions.useNapp) {
      return {
        hasPermission: false,
        isConfigured: false,
        isActive: false,
        isLoading: false,
        needsConfiguration: false,
        error: null
      };
    }

    // Se ainda está carregando
    if (loading) {
      return {
        hasPermission: true,
        isConfigured: false,
        isActive: false,
        isLoading: true,
        needsConfiguration: false,
        error: null
      };
    }

    // Se tem erro (que não seja 404 - não configurado)
    if (error) {
      return {
        hasPermission: true,
        isConfigured: false,
        isActive: false,
        isLoading: false,
        needsConfiguration: true,
        error
      };
    }

    // Se não tem config ou não tem token
    if (!config || !config.integrationToken || !config.integrationToken.trim()) {
      return {
        hasPermission: true,
        isConfigured: false,
        isActive: false,
        isLoading: false,
        needsConfiguration: true,
        error: null
      };
    }

    // Se tem config mas está inativa
    if (!config.active) {
      return {
        hasPermission: true,
        isConfigured: true,
        isActive: false,
        isLoading: false,
        needsConfiguration: false,
        error: null
      };
    }

    // Configurado e ativo
    return {
      hasPermission: true,
      isConfigured: true,
      isActive: true,
      isLoading: false,
      needsConfiguration: false,
      error: null
    };
  }, [permissions.useNapp, loading, error, config]);

  return status;
};

export default useNappStatus;